import z from 'zod';
import { cellCfgAttrsBaseSchema, cellCfgBaseSchema } from './cell-base.zod';
import { advancedProcessDisplaySchema } from './display-process.zod';

// Hidden cell type uses by work instructions to display processes as a flex column since there is a unknown number of processes per work instruction step
export const processListCellSchema = cellCfgBaseSchema.extend({
    type: z.literal('processList'),
    attrs: cellCfgAttrsBaseSchema.extend({
        processes: z.array(advancedProcessDisplaySchema),
        orientation: z.union([ z.literal('horizontal'), z.literal('vertical') ]).default('vertical'),
    }),
});
